<template>
  <div class="about">
    <!-- <section class="gallery container">
      <div class="grid3">
        <ElImage :src="imgs[0]" fit="cover" class="img" />
        <ElImage :src="imgs[1]" fit="cover" class="img" />
        <ElImage :src="imgs[2]" fit="cover" class="img" />
      </div>
    </section> -->

    <section class="text container">
      <h1 class="title">{{ noticeInfo?.title  }}</h1>
      <div v-if="noticeInfo?.content" v-html="noticeInfo.content" class="rich-content"></div>
    </section>

    <!-- <section class="promise">
      <div class="container">
        <h2 class="promise-title">品质的庄严承诺</h2>
        <p v-for="(p,i) in promise" :key="i" class="promise-para">{{ p }}</p>
      </div>
    </section> -->

    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import AppFooter from '@/components/AppFooter.vue'

const api = useApi()
const route = useRoute()
const noticeInfo = ref<any>(null)


const fetchInfo = async () => {
  const id = route.query.id || 4
  try {
    const res = await api.get<any>(`/shop/notice/info/${id}`, {}, { key: `notice-info-${id}` })
    const data = (res as any)?.data ?? (res as any)?.raw ?? {}
    if (data?.content) {
      data.content = data.content.replace(/<img /gi, '<img style="max-width:100%;height:auto;display:block;" ')
    }
    noticeInfo.value = data
  } catch (e) {
    console.error(e)
  }
}

await fetchInfo()

watch(
  () => route.query.id,
  () => {
    fetchInfo()
  }
)
</script>

<style scoped>
.about { font-size: 0.16rem; }
.container { width: 100%; padding: 0 0.9rem; }
.gallery { margin-top: 0.6rem; }
.grid3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.4rem; }
.img { width: 100%; height: 3rem; }
.text { max-width: 12rem; margin: 1rem auto; }
.title { text-align: center; font-size: 0.32rem; margin-bottom: 0.5rem; font-weight: 700; }
.para { color: #333; line-height: 2; margin-bottom: 0.24rem; }
.promise { background: #111; color: #fff; padding: 0.9rem 0; }
.promise-title { text-align: center; font-size: 0.26rem; margin-bottom: 0.3rem; }
.promise-para { line-height: 2; opacity: .9; margin-bottom: 0.2rem; }
@media (max-width: 960px) { .container { padding: 0 0.24rem; } .grid3 { grid-template-columns: 1fr; } .img { height: 2.4rem; } }
</style>
